import UpgradeToMenuDialog from "../components/ShopComponents/defaultGlobalTemplate/Dialogs/UpgradeToMenuDialog.vue";
import {pushGTMInternal} from "../integrations/tracking/gtm/pushGtmEvents";
import * as actions from "../store/mutation-types";

export default {
	components: {UpgradeToMenuDialog},
	data() {
		return {
			menuUpgradeDialog: {
				open: false,
				onClose: () => this.menuUpgradeDialog.open = false
			}
		};
	},
	methods: {
		getDialogData(pageType) {
			const self = this;
			switch(pageType){
			case "menuTileGt2":
			case "menuTileGt3":
				return self.menuTileData(pageType);
			case "defaultTileGt2":
			case "defaultTileGt3":
				return self.defaultTileData(pageType);
			}
		},
		menuTileData(pageType) {
			const self = this;
			const actionsMap = {
				menuTileGt2: {
					onClick1: () => {
						self.addToCart(self.item, {islargeMenuSelected: true}); 
						self.menuUpgradeDialog.onClose();
					},
					onClick2: () => { 
						self.addToCart(self.item); 
						self.menuUpgradeDialog.onClose();
					}
				},
				menuTileGt3: {
					onClick1: () => self.addToCart(self.item, {islargeMenuSelected: true}),
					onClick2: () => self.addToCart(self.item)
				}
			};
			return {
				item: self.item,
				menuItem: {...self.largeMenuItem, priceDifference: self.largeMenuItem.productPrice.discountPrice - self.item.productPrice.discountPrice},
				opened: self.menuUpgradeDialog.open,
				onClose: self.menuUpgradeDialog.onClose,
				formatPriceZero: self.formatPriceZero,
				backImg: self.backImg,
				question: self.$t("shopComponents.dialogs.upgradeToLargeMenu.question"),
				text1: self.$t("shopComponents.dialogs.upgradeToLargeMenu.largeMenu"),
				text2: self.$t("shopComponents.dialogs.upgradeToLargeMenu.regularMenu"),
				label: self.$t("shopComponents.dialogs.upgradeToLargeMenu.label"),
				promoText: self.$t("shopComponents.dialogs.upgradeToLargeMenu.promoText"),
				...actionsMap[pageType]
			};
		},
		defaultTileData(pageType) {
			const self = this;
			const key = self.productCatalog.departments.find(x=> x.id === self.item.product.departmentId).name.replace(/[& ]/g, "").toLowerCase();
			const actionsMap = {
				defaultTileGt2: {
					onClick1: async () => {
						const quantityBeforeAddingToCart = self.item.quantity;
						self.addToCart(self.item);
						self.menuUpgradeDialog.onClose();
						self.upgradeToMenu(self.item, self.menuItem);
						if(quantityBeforeAddingToCart === 0) {
							await self.$store.dispatch(actions.REMOVE_FROM_CART_BULK, self.item.productSelections);
						}
						pushGTMInternal(
							"select_upgrade_to_menu",
							this.item.product.name,
							this.$route.path,
							"product_page"
						);
					},
					onClick2: () => {
						if (self.item.quantity) {
							self.addQuantity(self.item);
							self.addToCart(self.item);
						} else {
							self.addToCart(self.item);
						}
						self.menuUpgradeDialog.onClose();
						self.openMenuDialog(self.item);
						pushGTMInternal(
							"select_keep_single",
							this.item.product.name,
							this.$route.path,
							"product_page"
						);
					}
				},
				defaultTileGt3: {
					onClick1: () => self.selectMenu(),
					onClick2: () => {
						self.performCartOperation(self.item, "ADD_TO_CART");
						self.menuUpgradeDialog.onClose();
					}
				}
			};
			return {
				item: self.item,
				menuItem: self.menuItem,
				opened: self.menuUpgradeDialog.open,
				onClose: self.menuUpgradeDialog.onClose,
				formatPriceZero: self.formatPriceZero,
				backImg: self.backImg,
				question: self.$t("shopComponents.dialogs.upgradeToRegularMenu.question"),
				text1: self.$t(`shopComponents.dialogs.upgradeToRegularMenu.MENU.${key}`),
				text2: self.$t(`shopComponents.dialogs.upgradeToRegularMenu.SINGLE.${key}`),
				label: self.$t("shopComponents.dialogs.upgradeToRegularMenu.label"),
				promoText: self.$t("shopComponents.dialogs.upgradeToRegularMenu.promoText"),
				makeMenuText: self.featureToggles.singleProductToMenuUpgradeWithNewDesign && self.$t("shopComponents.dialogs.upgradeToRegularMenu.makeMenuText"),
				singleMenuText: self.featureToggles.singleProductToMenuUpgradeWithNewDesign && self.$t("shopComponents.dialogs.upgradeToRegularMenu.singleMenuText"),
				friesAndRefillText: self.featureToggles.singleProductToMenuUpgradeWithNewDesign && self.$t("shopComponents.dialogs.upgradeToRegularMenu.friesAndRefillText"),
				...actionsMap[pageType]
			};
		}
	}
};
